module.exports = __webpack_public_path__ + "img/category-9.d41d8cd9.svg";